class SizeGuides extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['radio', 'size-guide']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.els.radio.elements.forEach(radioEl =>
      this.listeners.add(radioEl, 'change', this.handleRadioChange.bind(this)),
    )
  }

  handleRadioChange (event) {
    const selectedUnit = event.target.value

    this.els.radio.elements?.forEach(radioEl => {
      radioEl.toggleAttribute('checked', radioEl.value === selectedUnit)
    })

    this.els?.['size-guide']?.elements?.forEach(sizeGuideEl => {
      sizeGuideEl.setAttribute(
        'aria-hidden',
        sizeGuideEl.dataset.unitOfMeasurement?.toLowerCase() !==
          selectedUnit?.toLowerCase(),
      )
    })
  }
}

if (!window.customElements.get('size-guides')) {
  window.customElements.define('size-guides', SizeGuides)
}
